import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index18() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="intro-slider-container mb-3 mb-lg-5">
    <div className="intro-slider owl-carousel owl-theme owl-nav-inside owl-light" data-toggle="owl" data-owl-options="{&quot;dots&quot;: true, &quot;nav&quot;: false}">
      <div className="intro-slide" style={{backgroundImage: 'url(asset/images/demos/demo-18/slider/slide-1.jpg)'}}>
        <div className="container">
          <div className="intro-content text-center">
            <h3 className="intro-subtitle cross-txt text-primary">SEASONAL PICKS</h3>{/* End .h3 intro-subtitle */}
            <h1 className="intro-title text-white">Summer Sale</h1>{/* End .intro-title */}
            <div className="intro-text text-white">up to 70% off</div>{/* End .intro-text */}
            <div className="intro-action cross-txt">
              <a href="category.html" className="btn btn-outline-white">
                <span>Discover More</span>
              </a>
            </div>
          </div>
        </div>{/* End .intro-content */}
      </div>{/* End .intro-slide */}
      <div className="intro-slide" style={{backgroundImage: 'url(asset/images/demos/demo-18/slider/slide-2.jpg)'}}>
        <div className="container">
          <div className="intro-content text-center">
            <h3 className="intro-subtitle text-primary cross-txt">Women's Accessories</h3>{/* End .h3 intro-subtitle */}
            <h1 className="intro-title text-white">Save up to</h1>{/* End .intro-title */}
            <div className="intro-text text-white">30-50% off</div>{/* End .intro-text */}
            <div className="intro-action cross-txt">
              <a href="category.html" className="btn btn-outline-white">
                <span>Discover More</span>
              </a>
            </div>
          </div>
        </div>{/* End .intro-content */}
      </div>{/* End .intro-slide */}
    </div>{/* End .intro-slider owl-carousel owl-simple */}
    <span className="slider-loader text-white" />{/* End .slider-loader */}
  </div>{/* End .intro-slider-container */}
  <div className="container banners">
    <div className="row">
      <div className="col-lg-6">
        <div className="banner banner-hover">
          <a href="#">
            <img src="asset/images/demos/demo-18/banners/banner-1.jpg" alt="Banner" />
          </a>
          <div className="banner-content">
            <h3 className="banner-title text-white"><a href="#">Sweatshirts &amp; Hoodies</a></h3>{/* End .banner-title */}
            <a href="#" className="banner-link">Shop Now <i className="icon-long-arrow-right" /></a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
      </div>{/* End .col-lg-6 */}
      <div className="col-sm-6 col-lg-3">
        <div className="banner banner-hover">
          <a href="#">
            <img src="asset/images/demos/demo-18/banners/banner-2.jpg" alt="Banner" />
          </a>
          <div className="banner-content">
            <h3 className="banner-title text-white"><a href="#">Men’s Jacket</a></h3>{/* End .banner-title */}
            <a href="#" className="banner-link">Shop Now <i className="icon-long-arrow-right" /></a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
      </div>{/* End .col-sm-6 */}
      <div className="col-sm-6 col-lg-3">
        <div className="banner banner-hover">
          <a href="#">
            <img src="asset/images/demos/demo-18/banners/banner-3.jpg" alt="Banner" />
          </a>
          <div className="banner-content">
            <h3 className="banner-title text-white"><a href="#">Women’s jackets</a></h3>{/* End .banner-title */}
            <a href="#" className="banner-link">Shop Now <i className="icon-long-arrow-right" /></a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
        <div className="banner banner-hover">
          <a href="#">
            <img src="asset/images/demos/demo-18/banners/banner-4.jpg" alt="Banner" />
          </a>
          <div className="banner-content">
            <h3 className="banner-title text-white"><a href="#">Accessories</a></h3>{/* End .banner-title */}
            <a href="#" className="banner-link">Shop Now <i className="icon-long-arrow-right" /></a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
      </div>{/* End .col-sm-6 */}
    </div>{/* End .row */}
  </div>{/* End .container */}
  <div className="container">
    <div className="row">
      <div className="col-lg-9">
        <h2 className="title">Recent Arrivals</h2>{/* End .title */}
        <div className="products-container mb-7">
          <div className="row justify-content-center">
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-18/products/product-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-18/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Clothing</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Linen-blend dress</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $60.00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#e5dcb1'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#bacbd8'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <span className="product-label label-primary">Sale</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-18/products/product-2.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-18/products/product-2-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Shoes</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Sandals with lacing</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    <span className="new-price">Now $70.00</span>
                    <span className="old-price">Was $84.00</span>
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-18/products/product-3.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-18/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Clothing</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Paper bag trousers</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $60.00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#9fac76'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-18/products/product-4.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-18/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Handbags</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Bucket bag</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $350.00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#e3a84d'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#f48a5b'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-18/products/product-5.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-18/products/product-5-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Clothing</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Silk-blend kaftan</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $370.00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-18/products/product-6.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-18/products/product-6-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Clothing</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Linen-blend jumpsuit</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $595.00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-18/products/product-7.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-18/products/product-7-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Handbags</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Paper straw shopper</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $398.00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <span className="product-label label-sale">Sale</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-18/products/product-8.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-18/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Shoes</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Sandals</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    <span className="new-price">Now $120.00</span>
                    <span className="old-price">Was $140.00</span>
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-18/products/product-9.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-18/products/product-9-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Clothing</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Vest dress</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $9.99
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 */}
          </div>{/* End .row */}
          <div className="more-container text-center mt-0 mb-0">
            <a href="category.html" className="btn btn-outline-primary-2 btn-more">
              <span>View more Products</span>
            </a>
          </div>{/* End .more-container */}
        </div>{/* End .products */}
      </div>{/* End .col-lg-9 */}
      <aside className="col-lg-3">
        <div className="sidebar sidebar-home">
          <div className="row">
            <div className="col-sm-6 col-lg-12">
              <div className="widget widget-products">
                <h4 className="widget-title">Best Selling</h4>{/* End .widget-title */}
                <div className="products">
                  <div className="product product-sm">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-18/products/small/product-1.jpg" alt="Product image" className="product-image" />
                      </a>
                    </figure>
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Clothing</a>
                      </div>{/* End .product-cat */}
                      <h5 className="product-title"><a href="product.html">V-neck buttoned blouse</a></h5>{/* End .product-title */}
                      <div className="product-price">
                        <span className="new-price">Now $17.99</span>
                        <span className="old-price">Was $32.99</span>
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                  </div>{/* End .product product-sm */}
                  <div className="product product-sm">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-18/products/small/product-2.jpg" alt="Product image" className="product-image" />
                      </a>
                    </figure>
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Shoes</a>
                      </div>{/* End .product-cat */}
                      <h5 className="product-title"><a href="product.html">Slides with a bow</a></h5>{/* End .product-title */}
                      <div className="product-price">
                        $17.99
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                  </div>{/* End .product product-sm */}
                  <div className="product product-sm">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-18/products/small/product-3.jpg" alt="Product image" className="product-image" />
                      </a>
                    </figure>
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Clothing</a>
                      </div>{/* End .product-cat */}
                      <h5 className="product-title"><a href="product.html">Paper bag skirt</a></h5>{/* End .product-title */}
                      <div className="product-price">
                        $19.99
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                  </div>{/* End .product product-sm */}
                  <div className="product product-sm">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-18/products/small/product-4.jpg" alt="Product image" className="product-image" />
                      </a>
                    </figure>
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Handbags</a>
                      </div>{/* End .product-cat */}
                      <h5 className="product-title"><a href="product.html">Foldaway waist bag</a></h5>{/* End .product-title */}
                      <div className="product-price">
                        $9.99
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                  </div>{/* End .product product-sm */}
                </div>{/* End .products */}
              </div>{/* End .widget widget-products */}
            </div>{/* End .col-sm-6 col-lg-12 */}
            <div className="col-sm-6 col-lg-12">
              <div className="widget widget-subscribe" style={{backgroundImage: 'url(asset/images/demos/demo-18/bg-newsletter.jpg)'}}>
                <h2 className="widget-title">Sign up for email <br />&amp; get 25% off </h2>{/* End .widget-title */}
                <p>Subcribe to get information about products and coupons</p>
                <form action="#">
                  <input type="email" className="form-control" placeholder="Enter your Email Address" required />
                  <input type="submit" className="btn btn-outline-white" defaultValue="Subscribe" />
                </form>
              </div>{/* End .widget widget-banner */}
            </div>{/* End .col-sm-6 col-lg-12 */}
            <div className="col-sm-6 col-lg-12">
              <div className="widget widget-banner">
                <div className="banner banner-overlay">
                  <a href="#">
                    <img src="asset/images/demos/demo-18/banners/banner-5.jpg" alt="Banner" />
                  </a>
                  <div className="banner-content">
                    <h4 className="banner-subtitle"><a href="#">Spring 2019</a></h4>{/* End .banner-title */}
                    <h3 className="banner-title"><a href="#">SAVE UP TO <br />50% OFF</a></h3>{/* End .banner-title */}
                    <a href="#" className="banner-link">Shop Now</a>
                  </div>{/* End .banner-content */}
                </div>{/* End .banner */}
              </div>{/* End .widget widget-banner */}
            </div>{/* End .col-sm-6 col-lg-12 */}
            <div className="col-sm-6 col-lg-12">
              <div className="widget widget-posts">
                <h4 className="widget-title">New Blog Posts</h4>{/* End .widget-title */}
                <div className="owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
                              &quot;nav&quot;:false, 
                              &quot;dots&quot;: true, 
                              &quot;loop&quot;: false, 
                              &quot;autoHeight&quot;: true
                          }">
                  <article className="entry">
                    <figure className="entry-media">
                      <a href="single.html">
                        <img src="asset/images/demos/demo-18/blog/post-1.jpg" alt="image desc" />
                      </a>
                    </figure>{/* End .entry-media */}
                    <div className="entry-body">
                      <div className="entry-meta">
                        <a href="#">Nov 22, 2018</a>, 0 Comments
                      </div>{/* End .entry-meta */}
                      <h5 className="entry-title">
                        <a href="single.html">Sed adipiscing ornare.</a>
                      </h5>{/* End .entry-title */}
                      <div className="entry-content">
                        <p>Lorem ipsum dolor sit amet, consec tetuer adipiscing elit. Donec odio</p>
                        <a href="single.html" className="read-more">Read More</a>
                      </div>{/* End .entry-content */}
                    </div>{/* End .entry-body */}
                  </article>{/* End .entry */}
                  <article className="entry">
                    <figure className="entry-media">
                      <a href="single.html">
                        <img src="asset/images/demos/demo-18/blog/post-2.jpg" alt="image desc" />
                      </a>
                    </figure>{/* End .entry-media */}
                    <div className="entry-body">
                      <div className="entry-meta">
                        <a href="#">Nov 22, 2018</a>, 0 Comments
                      </div>{/* End .entry-meta */}
                      <h5 className="entry-title">
                        <a href="single.html">Aenean dignissim pellente sque felis.</a>
                      </h5>{/* End .entry-title */}
                      <div className="entry-content">
                        <p>Suspendisse urna nibh, viverra non, semper suscipit, posuere a, pede ...</p>
                        <a href="single.html" className="read-more">Read More</a>
                      </div>{/* End .entry-content */}
                    </div>{/* End .entry-body */}
                  </article>{/* End .entry */}
                </div>{/* End .owl-carousel */}
              </div>{/* End .widget widget-posts */}
            </div>{/* End .col-sm-6 col-lg-12 */}
          </div>{/* End .row */}
        </div>{/* End .sidebar sidebar-home */}
      </aside>{/* End .col-lg-3 */}
    </div>{/* End .row */}
    <hr className="mt-0 mb-4" />
    <h2 className="title text-center brands">Shop by Brands</h2>{/* End .title */}
    <div className="owl-carousel mt-3 mb-4 owl-simple" data-toggle="owl" data-owl-options="{
      &quot;nav&quot;: false, 
      &quot;dots&quot;: true,
      &quot;margin&quot;: 30,
      &quot;loop&quot;: false,
      &quot;responsive&quot;: {
          &quot;0&quot;: {
              &quot;items&quot;:2
          },
          &quot;420&quot;: {
              &quot;items&quot;:3
          },
          &quot;600&quot;: {
              &quot;items&quot;:4
          },
          &quot;900&quot;: {
              &quot;items&quot;:5
          },
          &quot;1024&quot;: {
              &quot;items&quot;:6
          },
          &quot;1200&quot;: {
              &quot;items&quot;:6,
              &quot;nav&quot;: true,
              &quot;dots&quot;: false
          }
      }
  }">
      <a href="#" className="brand">
        <img src="asset/images/brands/1.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/2.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/3.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/4.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/5.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/6.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/7.png" alt="Brand Name" />
      </a>
    </div>{/* End .owl-carousel */}
  </div>{/* End .container */}
  <div className="bg-lighter pt-5 pb-5">
    <div className="container">
      <div className="heading text-center">
        <h2 className="title instagram">Let Us Inspire You On Instagram</h2>{/* End .title */}
        <p className="title-desc">Donec nec justo eget felis facilisis fermentum.</p>{/* End .title-desc */}
      </div>{/* End .heading */}
      <div className="owl-carousel owl-simple mb-3" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: false,
          &quot;items&quot;: 5,
          &quot;margin&quot;: 20,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:2
              },
              &quot;360&quot;: {
                  &quot;items&quot;:2
              },
              &quot;600&quot;: {
                  &quot;items&quot;:3
              },
              &quot;992&quot;: {
                  &quot;items&quot;:4
              },
              &quot;1200&quot;: {
                  &quot;items&quot;:5
              }
          }
      }">
        <div className="instagram-feed">
          <img src="asset/images/demos/demo-18/instagram/1.jpg" alt="img" />
          <div className="instagram-feed-content">
            <a href="#"><i className="icon-heart-o" />466</a>
            <a href="#"><i className="icon-comments" />65</a>
          </div>{/* End .instagram-feed-content */}
        </div>{/* End .instagram-feed */}
        <div className="instagram-feed">
          <img src="asset/images/demos/demo-18/instagram/2.jpg" alt="img" />
          <div className="instagram-feed-content">
            <a href="#"><i className="icon-heart-o" />280</a>
            <a href="#"><i className="icon-comments" />22</a>
          </div>{/* End .instagram-feed-content */}
        </div>{/* End .instagram-feed */}
        <div className="instagram-feed">
          <img src="asset/images/demos/demo-18/instagram/3.jpg" alt="img" />
          <div className="instagram-feed-content">
            <a href="#"><i className="icon-heart-o" />123</a>
            <a href="#"><i className="icon-comments" />10</a>
          </div>{/* End .instagram-feed-content */}
        </div>{/* End .instagram-feed */}
        <div className="instagram-feed">
          <img src="asset/images/demos/demo-18/instagram/4.jpg" alt="img" />
          <div className="instagram-feed-content">
            <a href="#"><i className="icon-heart-o" />290</a>
            <a href="#"><i className="icon-comments" />0</a>
          </div>{/* End .instagram-feed-content */}
        </div>{/* End .instagram-feed */}
        <div className="instagram-feed">
          <img src="asset/images/demos/demo-18/instagram/5.jpg" alt="img" />
          <div className="instagram-feed-content">
            <a href="#"><i className="icon-heart-o" />582</a>
            <a href="#"><i className="icon-comments" />98</a>
          </div>{/* End .instagram-feed-content */}
        </div>{/* End .instagram-feed */}
      </div>{/* End .owl-carousel */}
      <div className="more-container text-center">
        <a href="#" className="btn btn-outline-primary-2 btn-more">@Molla Instagram</a>
      </div>{/* End .more-container */}
    </div>{/* End .container */}
  </div>{/* End .bg-lighter pt-5 pb-5 */}
</main>

        <UserFooter/>

    </div>
  )
}

export default Index18